const SET_STAGE = 'setStage'
const SET_STAGES = 'setStages'

export const mutationTypes = {
  SET_STAGE,
  SET_STAGES
}

export const mutations = {
  [SET_STAGE] (state, payload) {
    state.stage = payload
  },

  [SET_STAGES] (state, payload) {
    state.stages = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/stage/mutations.js